import React from 'react'
import { Helmet } from 'react-helmet'

const Desc = ({ title, description, keywords }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name='description' content={description} />
    </Helmet>
  )
}

Desc.defaultProps = {
  title: 'MEIA Platform',
  description:
    'MEIA platform....',
  
}

export default Desc
